export default "__VITE_ASSET__DISzO2xa__"